import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import TransformerTableDto from '../dto/TransformerTableDto';

class TransformerTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'transformerTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<TransformerTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, TransformerTableDto)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {string} name
	 * @return {Promise<any>}
	 */
	clone(id, name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/clone`, { id, name, })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

}

export default new TransformerTableService();